import baseApi from "@/api/baseApi";

export default{
  fetch(context) {
    return baseApi.get(`/api-piglet/api/delivery-addition/${context}/v1`);
  },
  fetchDefaultAdditions(form) {
    return baseApi.post('/api-piglet/api/delivery-addition/default-additions/v1', form);
  }
}
